import { render, staticRenderFns } from "./LayoutHeaderUserAuth.vue?vue&type=template&id=3598a1ae&lang=pug"
import script from "./LayoutHeaderUserAuth.vue?vue&type=script&lang=js"
export * from "./LayoutHeaderUserAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports